// Module
var code = "<div class=bible> <h2 class=passageref>Job 4.1</h2> <div class=bibletext> <p> </p><h2 class=plus-S>Eliphaz Speaks: Job Has Sinned</h2><p><span class=cc>4</span>Then Eliphaz the Temanite answered: </p> </div></div>";
// Exports
module.exports = code;